import React, { useEffect } from 'react';
import { connect,useDispatch } from 'react-redux';
import { compose } from 'redux';
import {getDataOnRequest} from '../redux/actions/CommonActions'
import { toast } from 'react-toastify';
const PoliciesAndProcedureContainer = (OriginalComponent) => {
  const NewComponent = (props) => {
    const dispatch = useDispatch();
    useEffect(()=>{
      toast.dismiss();
      if(props.userAuth.users_access_token)
        dispatch(getDataOnRequest(props.userAuth.users_access_token,'GetPoliciesAndProcedures','SET_POLICIES_AND_PROCEDURES'))
    }, [dispatch, props.userAuth.users_access_token]);

    return (
      <OriginalComponent {...props}  />
    )
  }
  return NewComponent
}

const mapStateToProps = (state) => {
  return {
    userAuth:state.auth.authUserData,
    userInfo:state.userProfile.userData,
    policies_and_procedures:state.policies_and_procedures.policies_and_procedures,
  };
};

const composedPoliciesAndProcedureContainer = compose(connect(mapStateToProps), PoliciesAndProcedureContainer)
export default composedPoliciesAndProcedureContainer;

